import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";


const getContractData = createAsyncThunk("api/contract", async (token) => {
  try {
     const response = await axios.get("/dashboard/contract", {
       headers: { Authorization: `Bearer ${token}` },
     });
     return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
})

const ContractDataSlice = createSlice({
  name: "contract",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContractData.fulfilled, (state, action) => {
        state.data = action.payload
        state.isLoading = false
      state.status = true
    }).addCase(getContractData.pending, (state, action) => {
      state.isLoading = true
    }).addCase(getContractData.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.error.message
    })
  }
});

export { getContractData }
export default ContractDataSlice.reducer